import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { Box } from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { selectPresenceUserColorMap } from 'store/presence/selectors';

import { surplusListStyles } from '../../PresenceAvatarGroup.styles';
import PresenceSurplusUser from '../PresenceSurplusUser';

const PresenceSurplusTooltipContent = ({ usersData }) => {
  const userColorMap = useSelector(selectPresenceUserColorMap);

  return (
    <Box sx={surplusListStyles}>
      {usersData.map(user => (
        <PresenceSurplusUser
          key={
            user.presenceData?.connectionId || user.userId || `${user.firstName}-${user.lastName}`
          }
          userColor={
            _.isNil(user.presenceData) ? null : userColorMap[user.presenceData.connectionId]
          }
          userData={user}
        />
      ))}
    </Box>
  );
};

PresenceSurplusTooltipContent.propTypes = {
  usersData: PropTypes.arrayOf(
    PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      roleName: PropTypes.string,
      userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      presenceData: PropTypes.shape({
        status: PropTypes.string,
        connectionId: PropTypes.string,
      }),
    }),
  ).isRequired,
};

export default memo(PresenceSurplusTooltipContent);
